import React from 'react';
import { Typography, Tooltip } from '@mui/material';
import { BsInfoCircleFill } from "react-icons/bs";

const SFInfoTooltip = ({name, tooltipText, placement}) => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            gap: "6px",
        }} >
            {name ? <div style={{ fontWeight: 700}}>{name}</div> : null}
            {tooltipText ?
                <Tooltip
                    title={<Typography className='text-white' fontSize={14}>
                        {tooltipText}
                    </Typography>}
                    placement={placement ? placement : 'top'}
                    arrow
                >
                    <span>
                        <BsInfoCircleFill color='#737373' size={14}
                            style={{
                                flexShrink: 0,
                                minWidth: "12px",
                                minHeight: "12px",
                                verticalAlign: "middle",
                                cursor: "pointer",
                            }} />
                    </span>
                </Tooltip>
                : null}
        </div>
    );
}

export default SFInfoTooltip;
